import { useTranslation } from "react-i18next";
import { initI18n } from "./i18n";
import { ArrowRightIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { Workflow } from "./interface";
import { getData } from "./backend";
import { INSTANT_WORKFLOW_SLUGS } from "./utils";
import AppOnboardingWorkflowsChat from "./AppOnboardingWorkflowsChat";
import InstantWorkflowCard from "./InstantWorkflowCard";
import HeroIcon from "./HeroIcon";

initI18n();

interface Props {
  token: string;
  onSelectWorkflow: (slug: string) => void;
}

function AppOnboardingWorkflows(props: Props) {
  const { t } = useTranslation();

  const instantWorkflows = [
    { "name": "Quotes", "icon": "Calculator", "slug": "quotes" },
    { "name": "Proposals", "icon": "Gift", "slug": "proposals" },
    { "name": "Contracts (eSign)", "icon": "PencilAlt", "slug": "contracts" },
  ]

  const [workflows, setWorkflows] = useState<Array<Workflow>>([]);

  const [prompt, setPrompt] = useState("");
  const [isClankerMode, setClankerMode] = useState(false);

  function submitPrompt() {
    if (prompt.length === 0)
      return

    setClankerMode(true);
  }

  useEffect(() => {
    getData(`/hubspot/onboarding/workflows/?slugs=${INSTANT_WORKFLOW_SLUGS.join(",")}`, props.token)
      .then(setWorkflows)
      .catch(console.error)
  }, [props.token]);

  if (isClankerMode)
    return <AppOnboardingWorkflowsChat instantWorkflows={workflows} prompt={prompt} {...props} />

  return (
    <div className="flex flex-col items-center gap-8">
      <div className="flex flex-col items-center">
        <div className="font-gilroy font-semibold text-gray-600 text-3xl">{t("What would you like to create?")}</div>
      </div>
      <div className="relative">
        <textarea className="border rounded w-[800px] resize-none h-full p-4" rows={3} placeholder={t("Describe the type of document you would like to create from your HubSpot data")} value={prompt} onChange={e => { setPrompt(e.currentTarget.value) }} onKeyDown={(e => { if (e.key === "Enter") { e.preventDefault(); submitPrompt() } })} />
        <button className="absolute bg-blue right-2 bottom-2 text-white py-2 px-3 rounded" onClick={submitPrompt}><ArrowRightIcon className="w-4 h-4" /></button>
      </div>

      <div className="flex flex-col items-center gap-4">
        <div className="font-semibold text-sm text-gray-400">{t("Choose a template and we will help you get started")}</div>
        <div className="flex gap-4 w-[800px]">
          {!workflows && instantWorkflows.map((workflow: any) => (
            <button key={workflow.slug} className="flex items-center justify-center gap-2 shadow border rounded py-4 w-1/3 font-semibold font-gilroy text-gray-600 cursor-pointer" onClick={() => props.onSelectWorkflow(workflow.slug)}>
              <HeroIcon icon={workflow.icon} className="w-6 h-6" />{workflow.name}
            </button>
          ))}
          {workflows.map((workflow) => <InstantWorkflowCard key={workflow.id} workflow={workflow} onSelect={(wkf) => props.onSelectWorkflow(wkf.publicWorkflowSlug)} />)}
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-2 w-96 text-gray-400">
            <div className="h-px bg-gray-400 w-full" />
            <div className="flex-shrink-0 text-sm">or</div>
            <div className="h-px bg-gray-400 w-full" />
          </div>
          <a href="https://app.portant.co" className="hover:underline hover:text-blue text-sm font-semibold text-gray-400">Start from Scratch</a>
        </div>
      </div>
    </div>
  );
}

export default AppOnboardingWorkflows;
